import { render, staticRenderFns } from "./UncleCakeDetail.vue?vue&type=template&id=02eae938&scoped=true"
import script from "./UncleCakeDetail.vue?vue&type=script&lang=js"
export * from "./UncleCakeDetail.vue?vue&type=script&lang=js"
import style0 from "./UncleCakeDetail.vue?vue&type=style&index=0&id=02eae938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02eae938",
  null
  
)

export default component.exports